// Actions
const FLAG = "GLOBAL/FLAG"; // isOpen the sidebar?
const sliderActive = "GLOBAN_SLIDER_ACTIVE"; // 侧边栏激活项

const defaultState = {
  collapsed: false,
  sliderActive: null
};

/*
 * Reducer
 */
export default function Reducer(state = defaultState, action) {
  switch (action.type) {
    case FLAG:
      return {
        ...state,
        collapsed: !state.collapsed
      };
    case sliderActive:
      return {
        ...state,
        sliderActive: action.payload
      };
    default:
      return state;
  }
}
// 侧边栏开关
export const CreateCollapsedAction = () => {
  return dispatch => {
    dispatch({
      type: FLAG
    });
  };
};

// sider激活点亮
export const createSliderActive = num => dispatch => {
  dispatch({
    type: sliderActive,
    payload: num
  });
};



// WEBPACK FOOTER //
// ./src/redux/Global.jsx